module.exports = __webpack_public_path__ + "img/accordion.8d9d7a4c.png";